import React from "react";
import { Modal, List, Avatar } from "antd";
import FileUploadDragger from "./FileUploadDragger";
import { Job } from "../../../../Entities/Job";

interface TestProps {
  showFileUploadModal: boolean | undefined;
  handleModalClose: () => void;
  jobDescriptionId: string;
  setShowFileUploadModal: (show: boolean) => void;
  handleNewJobAdd: (job: Job | null) => void;
}

const FileUploadModal: React.FC<TestProps> = ({
  handleModalClose,
  showFileUploadModal,
  jobDescriptionId,
  setShowFileUploadModal,
  handleNewJobAdd,
}) => {
  const processSteps = [
    {
      title: "Upload Candidate Resume",
      description:
        "Admins can upload a candidate's resume file, and the system will automatically extract and save the candidate's details.",
    },
    {
      title: "AI Profile Matching",
      description:
        "The extracted candidate details will be matched against the job requirements using AI to determine the suitability.",
    },
    {
      title: "AI-Powered Interview",
      description:
        "Qualified candidates will automatically receive an email inviting them to participate in an AI-driven interview.",
    },
  ];

  return (
    <Modal
      title="File Upload"
      visible={showFileUploadModal}
      onCancel={handleModalClose}
      footer={null}
      centered
      width={600}
      destroyOnClose
    >
      <List
        itemLayout="horizontal"
        dataSource={processSteps}
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar>{index + 1}</Avatar>}
              title={item.title}
              description={item.description}
            />
          </List.Item>
        )}
      />
      <FileUploadDragger
        jobDescriptionId={jobDescriptionId}
        setShowUploadModal={setShowFileUploadModal}
        handleNewJobAdd={handleNewJobAdd}
      />
    </Modal>
  );
};

export default FileUploadModal;
